module.exports = __webpack_public_path__ + "img/custom-logo-yellow.05c09aa0.svg";